<template>
    <article class="container">
        <div class="content">
            <div class="section-heading">
                <h1>Terms and Conditions</h1>
            </div>
            <div class="widget-box" v-html="store.terms_conditions">
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'termsConditions',
        metaInfo() {
            if(this.$store.state.siteSetting) {

              let ss = this.$store.state.siteSetting;

              let title = this.$getSafe(() => ss.terms_and_conditions_meta_title);
              let description = this.$getSafe(() => ss.terms_and_conditions_meta_description);
              let keywords = this.$getSafe(() => ss.terms_and_conditions_meta_keywords);

              return {
                  title: title,
                  description: description,
                  meta: this.$getMetaTags(title, description,keywords),
                  link:[
                    {rel: 'canonical', href: this.$toFullPath(this.$route.fullPath)}
                  ],
              }
            }
        },
        data() {
          return{
            store : {},
          }
        },
        mounted() {
          this.store = this.$store.state.siteSetting;
        },
        created() {
//            console.log(isBrowser+"test");
        },
    }
</script>
